var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Mapbox',{attrs:{"access-token":_vm.token,"map-options":{
      style: 'mapbox://styles/mapbox/streets-v11?optimize=true',
      center: [-100.04, 38.907],
      zoom: 3,
    }},on:{"map-load":_vm.loaded,"map-click:states-layer":_vm.handleMapClickStates,"map-click:beach-layer":_vm.handleMapClickOther,"map-click:contract-layer":_vm.handleMapClickOther,"map-moveend":_vm.handleMove,"map-mouseenter:states-layer":function($event){return _vm.toggleCursor(true)},"map-mouseleave:states-layer":function($event){return _vm.toggleCursor(false)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }